import React, { useEffect } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import logoImg from '../../../../../assets/images/logo2.png';

import ProfileIconCard from '../../../../../components/ProfileIconCard/ProfileIconCard';
import { InlineTextButton, NamedLink } from '../../../../../components';

import { ACCOUNT_SETTINGS_PAGES } from '../../../../../routing/routeConfiguration';

import css from './SideBar.module.css';
import { abilityToSell, USER_TYPE_YOUTH } from '../../../../../util/types';
import { currentUserRole, getUserPermissions } from '../../../../../util/data';

const SideBar = (props) => {

  const {
    isOpen,
    onClose,
    FeedTabComponent,
    SpaceGroupsComponent,
    JoinedGroupsComponent,
    FilterOptionsComponent,
    onLogout,
    currentPage,
    currentUser
  } = props;

  useEffect(() => {
    // Disable background scroll when sidebar is open
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    // Cleanup on component unmount
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  const currentPageClass = page => {
    const isAccountSettingsPage =
      page === 'AccountSettingsPage' && ACCOUNT_SETTINGS_PAGES.includes(currentPage);
    const isInboxPage = currentPage?.indexOf('InboxPage') === 0 && page?.indexOf('InboxPage') === 0;
    return currentPage === page || isAccountSettingsPage || isInboxPage ? css.currentPage : null;
  };

  const { publicData, protectedData, privateData } = (currentUser && currentUser.id && currentUser.attributes?.profile) || {};
  const { userRole, parentId = false } = publicData || {};
  const { subscriptionData = false } = protectedData || {};
  const { isSupabaseAdmin } = privateData || {};

  const userSubscriptionRole = currentUserRole(currentUser);
  const userAbilityToSell = getUserPermissions(userSubscriptionRole, abilityToSell);

  return (
    <>
      <div className={`${css.overlay} ${isOpen ? css.overlayVisible : ''}`} onClick={onClose}></div>
      <div className={`${css.sideBar} ${isOpen ? css.open : ''}`}>
        <button className={css.closeButton} onClick={onClose}>
          <ProfileIconCard type="cross" />
        </button>
        <div className={css.content}>
          <img src={logoImg} />
          {FeedTabComponent}
          {(SpaceGroupsComponent || JoinedGroupsComponent || FilterOptionsComponent) && <div className={css.spacer}></div>}
          {FilterOptionsComponent}
          {SpaceGroupsComponent}
          {JoinedGroupsComponent}
        </div>
        <div>
          <div className={css.accountLinksWrapper}>
            {
              (userRole !== USER_TYPE_YOUTH && (subscriptionData || !parentId)) ?
                <>
                  {userAbilityToSell && <NamedLink
                    className={classNames(css.navigationLink, currentPageClass('ManageListingsPage'))}
                    name="ManageListingsPage"
                  >
                    <FormattedMessage id="TopbarMobileMenu.yourListingsLink" />
                  </NamedLink>}
                  <NamedLink
                    className={classNames(css.navigationLink, currentPageClass('ManageListingsPage'))}
                    name="CartPage"
                  >
                    <FormattedMessage id="TopbarMobileMenu.cartLink" />
                  </NamedLink>
                </>
                : null
            }
            <NamedLink
              className={classNames(css.navigationLink, currentPageClass('ProfileSettingsPage'))}
              name="ProfileSettingsPage"
            >
              <FormattedMessage id="TopbarMobileMenu.profileSettingsLink" />
            </NamedLink>
            <NamedLink
              className={classNames(css.navigationLink, currentPageClass('AccountSettingsPage'))}
              name="AccountSettingsPage"
            >
              <FormattedMessage id="TopbarMobileMenu.accountSettingsLink" />
            </NamedLink>

            <NamedLink
              className={classNames(css.navigationLink, currentPageClass('StripeSubscriptionPage'))}
              name="StripeSubscriptionPage"
            >
              <FormattedMessage id="UserNav.stripeSubscriptionPage" />
            </NamedLink>

            {isSupabaseAdmin && <NamedLink
              className={classNames(css.menuLink, currentPageClass('AdminPanelSupabasePage'))}
              name="AdminPanelSupabasePage"
              params={{ tab: "general" }}
            >
              <span className={css.menuItemBorder} />
              <FormattedMessage id="TopbarDesktop.adminPanelLink" />
            </NamedLink>}

            <InlineTextButton rootClassName={css.logoutButton} onClick={onLogout}>
              <FormattedMessage id="TopbarMobileMenu.logoutLink" />
            </InlineTextButton>
          </div>
        </div>
      </div>
    </>
  );
};

export default SideBar;
